import React from 'react';
import styles from './styles.module.scss';

type ContainerProps = {
    children?: React.ReactNode
    style?: React.CSSProperties
    width?: string
}

const Container = ({ children, style, width }: ContainerProps) => {
  return (
    <div className={styles.contenedor} style={{ maxWidth: width ?? '1000px', ...style }}>
      {children}
    </div>
  );
};

export default Container;
